import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core'

@Component({
    selector: 'app-keycom-container',
    templateUrl: './app-container.component.html',
    styleUrls: ['./app-container.component.scss'],
    standalone: false
})
export class AppContainerComponent implements OnInit {
  @Input() logo
  @Input() navButtons
  @Input() title
  @Input() breadcrumb
  @Input() user

  @Output() profileAction: EventEmitter<any> = new EventEmitter()
  @Output() helpAction: EventEmitter<any> = new EventEmitter()

  constructor() {}

  ngOnInit() {}

  onProfileAction(profileAction) {
    this.profileAction.emit(profileAction)
  }

  onHelpAction(profileAction) {
    this.helpAction.emit(profileAction)
  }
}
